import React, { createContext, useReducer, useContext } from 'react';

// Action Types
export const ParticipantActionTypes = {
  LOAD_PARTICIPANTS: 'LOAD_PARTICIPANTS',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  CLEAR_CACHE: 'CLEAR_CACHE',
  UPDATE_PARTICIPANT: 'UPDATE_PARTICIPANT',
};

// Initial State
const initialState = {
  participants: [],
  loading: false,
  error: null,
  loadedFromApi: false,
  lastUpdated: null,
};

// Reducer
function participantReducer(state, action) {
  switch (action.type) {
    case ParticipantActionTypes.LOAD_PARTICIPANTS:
      return {
        ...state,
        participants: action.payload,
        loadedFromApi: action.fromApi || false,
        lastUpdated: new Date().toISOString(),
        loading: false,
        error: null,
      };
    
    case ParticipantActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    
    case ParticipantActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    
    case ParticipantActionTypes.CLEAR_CACHE:
      return {
        ...initialState,
      };
    
    case ParticipantActionTypes.UPDATE_PARTICIPANT:
      return {
        ...state,
        participants: state.participants.map(p =>
          p.id === action.payload.id ? { ...p, ...action.payload } : p
        ),
        lastUpdated: new Date().toISOString(),
      };
    
    default:
      return state;
  }
}

// Create Context
export const ParticipantStoreContext = createContext({
  ...initialState,
  dispatch: undefined,
});

// Provider Component
export const ParticipantStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(participantReducer, initialState);

  return (
    <ParticipantStoreContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ParticipantStoreContext.Provider>
  );
};

// Custom Hook for easy access
export const useParticipantStore = () => {
  const context = useContext(ParticipantStoreContext);
  if (!context) {
    throw new Error('useParticipantStore must be used within ParticipantStoreProvider');
  }
  return context;
};

export default ParticipantStoreProvider;
